/* global G */
import { arrayOf, curry, def } from 'lib/util'

/**
 * Recursively nests a property for each part of the `component`'s path in the action's
 * cache. Then, stores the `event`'s detail as a `_cache` object in the deepest object
 * created inside cache with the component's path. It results in an object tree that represents the
 * paths of component's keys to the components whose state was altered.
 *
 * @type {Gaia.AppModule.EventHandler}  event handler
 */
const remember = async (module, component, event) => {
  const actionData = module[G.STATE][G.ACTION][G.DATA]
  const componentProps = component[G.PROPS]
  const path = componentProps[G.ROUTE]
  const { limit } = componentProps
  const { detail } = event
  const details = { ...def(detail.item) ? { value: arrayOf(detail.item) } : detail }
  const props = { ...details } // breaking references
  const timestamp = new Date()

  // we don't want to cache list data that only contains a single page
  // but remember the scroll position regardless
  const shouldCache = !props.data || (props.data.length > limit)
  const rememberedProps = shouldCache ? props : { scrollPosition: props.scrollPosition }

  const target = path.reduce((acc, item) => {
    acc[item] = { ...acc[item] }
    return acc[item]
  }, actionData)

  // throw away old list cache (data, page, unsegmented) if we do not want to cache the current list
  const { data, page, unsegmented, ...nonListProps } = target._cache?.props || {}
  const cachedProps = shouldCache ? target._cache?.props : nonListProps

  if (shouldCache || rememberedProps.scrollPosition !== undefined) {
    target._cache = { props: { ...cachedProps, ...rememberedProps }, timestamp }
  }
}

export default curry(remember)
